<template>
<!-- eslint-disable max-len -->
<span>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <metrics v-if="showMetrics" :showCash="this.showCash" id="metrics" animate></metrics>
  </transition>
  <bottom-bar :next="this.showButton ? next : undefined">
    <span slot="button">
      <span>{{(game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next'}}</span>
    </span>
  </bottom-bar>
</span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import Metrics from '../ui/Metrics';
import TopBar from '../ui/TopBar';
import BottomBar from '../ui/BottomBar';
import DecisionResult from '../ui/DecisionResult';

export default {
  components: {
    Metrics,
    TopBar,
    BottomBar,
    DecisionResult
  },
  data() {
    return {
      showMetrics: false,
      showButton: false
    };
  },
  computed: {
    ...mapGetters([
      'resultsBackground',
      'complete',
      'lastTeamDecision',
      'teamDecision',
      'finalTeamDecisionComplete',
      'game'
    ]),
    showCash() {
      if (this.currentState === this.resultsState && !this.complete) {
        if (this.lastTeamDecision != null) {
          return !(this.lastTeamDecision.hideCashInResults);
        }
        return true;
      }
      if (this.teamDecision != null) {
        return !(this.teamDecision.hideCashInResults);
      }
      return true;
    }
  },
  methods: {
    ...mapActions([
      'setResultsViewed',
      'stopSounds'
    ]),
    async next() {
      this.setResultsViewed();
      await Vue.nextTick();
      this.$router.nextGameState();
    }
  },
  created() {
    let skip = false;
    // TODO: I think this check is now unnecessary and we can just use the else body.
    //       Shouldn't be causing any harm though.
    if (this.finalTeamDecisionComplete) {
      skip = this.teamDecision != null
        ? this.teamDecision.skipResults
        : (this.lastTeamDecision != null ? this.lastTeamDecision.skipResults : false);
    } else {
      skip = this.lastTeamDecision != null
        ? this.lastTeamDecision.skipResults
        : (this.teamDecision != null ? this.teamDecision.skipResults : false);
    }
    if (skip) {
      this.next();
    }
  },
  async mounted() {
    await Vue.nextTick();
    this.stopSounds();
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.showMetrics = true;
    await new Promise(resolve => setTimeout(resolve, 2000));
    this.showButton = true;
  }
};
</script>

<style lang="scss" scoped>
#metrics {
  position: absolute;
  bottom: 220px;
  left: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/Results.vue